<template>
  <div class="pane-container">
    <div class="left">
      <img :src="img" class="portrait" />
    </div>
    <div class="right">
      <img
        class="quote-img"
        src="@/assets/img/icons/quote-large.png"
        alt="Diversity in graduate recruitment quote" />
      <p class="quote">
        {{ quote }}
      </p>
      <p class="name">
        <b>{{ name }}</b>, {{ position }}
      </p>
      <div class="logo">
        <img :src="logo" class="logo-img" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TestimonialCarouselSlide',
  props: {
    quote: String,
    img: String,
    name: String,
    position: String,
    logo: String,
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .pane-container {
    width: 83.5vw;
    min-height: 450px;
    max-height: 100%;
    display: flex;
    align-items: flex-start;
    overflow: visible;
  }

  .left {
    max-width: 450px;
    height: 100%;
    margin-right: 50px;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    align-self: flex-start;
    overflow: visible;
  }

  .right {
    width: calc(100% - 500px);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-content: flex-start;
    align-self: flex-start;
  }

  .portrait {
    max-width: 450px;
  }

  .quote-img {
    height: 48px;
    margin-bottom: 16px;
    width: 79px;
  }

  .quote {
    padding-right: 10px;
    font-size: 20px;
    line-height: 1.78;
    letter-spacing: 2px;
    text-transform: uppercase;
    white-space: normal;
    word-break: normal;
    overflow-wrap: normal;
  }

  .name {
    font-size: 24px;
    line-height: 1.52;
  }

  .logo-img {
    max-width: 300px;
    max-height: 60px;
    margin-top: 8px;
  }

  @media only screen and (max-width: 1000px)  {
    .logo-img {
      max-width: 100%;
    }
  }

  @media only screen and (max-width: 800px)  {
    .pane-container {
      flex-direction: column;
      min-height: auto;
      max-height: auto;
    }

    .left {
      max-width: 100%;
      margin: 0;
      justify-content: center;
      align-items: center;
      align-content: center;
      align-self: center;
    }

    .quote-img {
      height: 33px;
      margin: 20px 10px 16px 0;
      width: 42px;
    }

    .logo-img {
      max-width: 200px;
      max-height: 40px;
      margin-top: 8px;
    }

    .portrait {
      max-width: 90%;
    }

    .quote {
      font-size: 14px;
      font-weight: 300;
      line-height: 1.71;
      letter-spacing: 2px;
    }

    .name {
      font-size: 18px;
      line-height: 1.52;
    }

    .right {
      width: 100% !important;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/carousels/testimonialCarousel/testimonialCarouselSlide.vue